import dayjs from 'dayjs'
import {delivery_new_lsrm, delivery_new_lsp, delivery_newSearch} from './delivery_new.js'
const config = {
    'searchList': {
        'searchTxt': []
    },
    'companySearch': {
        'searchTxt': [
            {
                'name': '考核月份',
                'value': 'month',
                'type': 'time',
                'timeType': 'month',
                'placeholder': '考核月份',
                'format': 'yyyy-MM',
                'unfold': true,
                'span': 4,
            },
            {
                name: '分公司',
                value: 'companyName',
                type: 'advance',
                advanceUrl: '/esCompany/popCompany',
                unfold: true,
                searchRequired: true,
                span: 3,
                advanceLabel: '分公司弹出框',
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                tableConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
            },
            {
                'name': '供应商编码',
                'value': 'supplierCode',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '供应商名称',
                'value': 'supplierNameCn',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '绩效等级',
                'value': 'performanceStarRating',
                'type': 'select',
                'unfold': true,
                'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                'options': [],
                'span': 3
            },
            {
                'name': '是否申诉',
                'value': 'isAppeal',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
            {
                name: '绩效状态',
                value: 'performanceStatus',
                type: 'select',
                unfold: true,
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                'options': [],
                span: 3,
            },
            {
                'name': '是否发文',
                'value': 'isPosting',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
            {
                'name': '帮扶计划提交',
                'value': 'isSubmitHelpPlan',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
        ],
        'unfoldState': false,
        'advancedBtn': true,
        'resetBtn': true
    },
    'companyClientSearch': {
        'searchTxt': [
            {
                'name': '考核月份',
                'value': 'month',
                'type': 'time',
                'timeType': 'month',
                'placeholder': '考核月份',
                'format': 'yyyy-MM',
                'unfold': true,
                'span': 4,
            },
            {
                name: '分公司',
                value: 'companyName',
                type: 'advance',
                advanceUrl: '/esCompany/popCompany',
                unfold: true,
                searchRequired: true,
                span: 3,
                advanceLabel: '分公司弹出框',
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                tableConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
            },
            {
                'name': '内外部客户',
                'value': 'customerType',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '内部客户', value: '1' },
                    { label: '外部客户', value: '2' },
                ],
                'span': 4
            },
            {
                'name': '供应商编码',
                'value': 'supplierCode',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '供应商名称',
                'value': 'supplierNameCn',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '绩效等级',
                'value': 'performanceStarRating',
                'type': 'select',
                'unfold': true,
                'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                'options': [],
                'span': 3
            },
            {
                'name': '是否申诉',
                'value': 'isAppeal',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
            {
                name: '绩效状态',
                value: 'performanceStatus',
                type: 'select',
                unfold: true,
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                'options': [],
                span: 3,
            },
            {
                'name': '是否发文',
                'value': 'isPosting',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
            {
                'name': '帮扶计划提交',
                'value': 'isSubmitHelpPlan',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
        ],
        'unfoldState': false,
        'advancedBtn': true,
        'resetBtn': true
    },
    'businessSearch': {
        'searchTxt': [
            {
                'name': '考核月份',
                'value': 'month',
                'type': 'time',
                'timeType': 'month',
                'placeholder': '考核月份',
                'format': 'yyyy-MM',
                'unfold': true,
                'span': 4,
            },
            {
                name: '分公司',
                value: 'companyName',
                type: 'advance',
                advanceUrl: '/esCompany/popCompany',
                unfold: true,
                searchRequired: true,
                span: 3,
                advanceLabel: '分公司弹出框',
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                tableConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
            },
            {
                name: '经营中心',
                value: 'businessCenterName',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                'name': '供应商编码',
                'value': 'supplierCode',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '供应商名称',
                'value': 'supplierNameCn',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '绩效等级',
                'value': 'performanceStarRating',
                'type': 'select',
                'unfold': true,
                'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                'options': [],
                'span': 3
            },
            {
                'name': '是否申诉',
                'value': 'isAppeal',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
            {
                name: '绩效状态',
                value: 'performanceStatus',
                type: 'select',
                unfold: true,
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                'options': [],
                span: 3,
            },
            {
                'name': '是否发文',
                'value': 'isPosting',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
            {
                'name': '帮扶计划提交',
                'value': 'isSubmitHelpPlan',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
        ],
        'unfoldState': false,
        'advancedBtn': true,
        'resetBtn': true
    },
    'businessClientSearch': {
        'searchTxt': [
            {
                'name': '考核月份',
                'value': 'month',
                'type': 'time',
                'timeType': 'month',
                'placeholder': '考核月份',
                'format': 'yyyy-MM',
                'unfold': true,
                'span': 4,
            },
            {
                name: '分公司',
                value: 'companyName',
                type: 'advance',
                advanceUrl: '/esCompany/popCompany',
                unfold: true,
                searchRequired: true,
                span: 3,
                advanceLabel: '分公司弹出框',
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                tableConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
            },
            {
                name: '经营中心',
                value: 'businessCenterName',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                'name': '内外部客户',
                'value': 'customerType',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '内部客户', value: '1' },
                    { label: '外部客户', value: '2' },
                ],
                'span': 4
            },
            {
                'name': '供应商编码',
                'value': 'supplierCode',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '供应商名称',
                'value': 'supplierNameCn',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '绩效等级',
                'value': 'performanceStarRating',
                'type': 'select',
                'unfold': true,
                'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                'options': [],
                'span': 3
            },
            {
                'name': '是否申诉',
                'value': 'isAppeal',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
            {
                name: '绩效状态',
                value: 'performanceStatus',
                type: 'select',
                unfold: true,
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                'options': [],
                span: 3,
            },
            {
                'name': '是否发文',
                'value': 'isPosting',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
            {
                'name': '帮扶计划提交',
                'value': 'isSubmitHelpPlan',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
        ],
        'unfoldState': false,
        'advancedBtn': true,
        'resetBtn': true
    },
    'platformSearch': {
        'searchTxt': [
            {
                'name': '考核月份',
                'value': 'month',
                'type': 'time',
                'timeType': 'month',
                'placeholder': '考核月份',
                'format': 'yyyy-MM',
                'unfold': true,
                'span': 4,
            },
            {
                name: '分公司',
                value: 'companyName',
                type: 'advance',
                advanceUrl: '/esCompany/popCompany',
                unfold: true,
                searchRequired: true,
                span: 3,
                advanceLabel: '分公司弹出框',
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                tableConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
            },
            {
                name: '经营中心',
                value: 'businessCenterName',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '服务平台',
                value: 'siteName',
                type: 'advance',
                unfold: true,
                searchRequired: true,
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                ],
                tableConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                ],
                advanceUrl: '/searchPlatform',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                span: 3,
                advanceCascade: `companyCode#companyCode`,
            },
            {
                'name': '供应商编码',
                'value': 'supplierCode',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '供应商名称',
                'value': 'supplierNameCn',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '绩效等级',
                'value': 'performanceStarRating',
                'type': 'select',
                'unfold': true,
                'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                'options': [],
                'span': 3
            },
            {
                'name': '是否申诉',
                'value': 'isAppeal',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
            {
                name: '绩效状态',
                value: 'performanceStatus',
                type: 'select',
                unfold: true,
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                'options': [],
                span: 3,
            },
            {
                'name': '是否发文',
                'value': 'isPosting',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
            {
                'name': '帮扶计划提交',
                'value': 'isSubmitHelpPlan',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
        ],
        'unfoldState': false,
        'advancedBtn': true,
        'resetBtn': true
    },
    'clientSearch': {
        'searchTxt': [
            {
                'name': '考核月份',
                'value': 'month',
                'type': 'time',
                'timeType': 'month',
                'placeholder': '考核月份',
                'format': 'yyyy-MM',
                'unfold': true,
                'span': 4,
            },
            {
                name: '分公司',
                value: 'companyName',
                type: 'advance',
                advanceUrl: '/esCompany/popCompany',
                unfold: true,
                searchRequired: true,
                span: 3,
                advanceLabel: '分公司弹出框',
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                tableConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
            },
            {
                name: '经营中心',
                value: 'businessCenterName',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '服务平台',
                value: 'siteName',
                type: 'advance',
                unfold: true,
                searchRequired: true,
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                ],
                tableConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                ],
                advanceUrl: '/searchPlatform',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                span: 3,
                advanceCascade: `companyCode#companyCode`,
            },
            {
                'name': '内外部客户',
                'value': 'customerType',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '内部客户', value: '1' },
                    { label: '外部客户', value: '2' },
                ],
                'span': 4
            },
            {
                'name': '供应商编码',
                'value': 'supplierCode',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '供应商名称',
                'value': 'supplierNameCn',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '绩效等级',
                'value': 'performanceStarRating',
                'type': 'select',
                'unfold': true,
                'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                'options': [],
                'span': 3
            },
            {
                'name': '是否申诉',
                'value': 'isAppeal',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
            {
                name: '绩效状态',
                value: 'performanceStatus',
                type: 'select',
                unfold: true,
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                'options': [],
                span: 3,
            },
            {
                'name': '是否发文',
                'value': 'isPosting',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
            {
                'name': '帮扶计划提交',
                'value': 'isSubmitHelpPlan',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
        ],
        'unfoldState': false,
        'advancedBtn': true,
        'resetBtn': true
    },
    'lspSearch': {
        'searchTxt': [
            {
                'name': '考核月份',
                'value': 'month',
                'type': 'time',
                'timeType': 'month',
                'placeholder': '考核月份',
                'format': 'yyyy-MM',
                'unfold': true,
                'span': 4,
            },
            {
                name: '分公司',
                value: 'companyName',
                type: 'advance',
                advanceUrl: '/esCompany/popCompany',
                unfold: true,
                searchRequired: true,
                span: 3,
                advanceLabel: '分公司弹出框',
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                tableConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
            },
            {
                name: '经营中心',
                value: 'businessCenterName',
                type: 'input',
                unfold: true,
                span: 3,
                visible: '2,3,6,7',
            },
            {
                name: '服务平台',
                value: 'siteName',
                type: 'advance',
                unfold: true,
                searchRequired: true,
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                ],
                tableConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                ],
                advanceUrl: '/searchPlatform',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                span: 3,
                advanceCascade: `companyCode#companyCode`,
                visible: '2,3',
            },
            {
                'name': '内外部客户',
                'value': 'customerType',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '内部客户', value: '1' },
                    { label: '外部客户', value: '2' },
                ],
                'span': 4,
                visible: '3,5,7',
            },
            {
                'name': '绩效等级',
                'value': 'performanceStarRating',
                'type': 'select',
                'unfold': true,
                'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                'options': [],
                'span': 3
            },
            {
                'name': '是否申诉',
                'value': 'isAppeal',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                'span': 3
            },
            {
                name: '绩效状态',
                value: 'performanceStatus',
                type: 'select',
                unfold: true,
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                'options': [],
                span: 3,
            },
        ],
        'unfoldState': false,
        'advancedBtn': true,
        'resetBtn': true
    },
    delivery_newSearch,
    'table': { columns: [] },
    'lsrm': {
        'delivery': {
            'companyTable': {
                'pageId': 'legal-perform-lsrm1',
                'searchId': 'legal-perform-lsrm1-sd',
                'leftOperation': true,
                'leftWidth': 250,
                'selectBtn': true,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '全国排名',
                        'prop': 'ranking',
                        'width': '120px',
                        'info': '分公司层级下，全国供应商绩效排名'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：报表发车是否及时等于及时的所有TK单数求和</div><div>应发货数量：取该供应商要求发车时间在当月的所有运输单计数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-发车及时率明细</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：报表签收是否及时等于及时的所有TK单数求和</div><div>到货总数量：取该供应商要求签收时间在当月的所有运输单计数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：城配来自报表配送及时率/干线指标来自到货及时率</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：报表电子回单上传等于及时的所有TK单数求和</div><div>回单总数量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-回单全链路明细报表</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：该供应商的完好商品件数求和</div><div>货物总数量：取该供应商签收时间在当月的所有商品的件数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-异常签收明细报表</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '运力线上化率(%)',
                        'prop': 'onlineRateOfTransportationCapacity',
                        'width': '160px',
                        'info': '<div>运力线上化率=线上化单数/线上考核单数</div><div>线上化单数：取该供应商的所有正向订单，且发车，抵达，在途属于自动在线的TK单数求和</div><div>线上考核单数：取该供应商的所有正向订单，且发车，抵达，在途的所有TK单数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-订单自动化采集汇总表(仅限城配/配送业务数据/干线数据无此指标)</div>'
                    },
                    {
                        'label': '运力线上化率得分',
                        'prop': 'onlineRateOfTransportationCapacityScore',
                        'width': '140px'
                    },
                    {
                        'label': '线上考核单数',
                        'prop': 'ontrackAllCntTotal',
                        'width': '140px'
                    },
                    {
                        'label': '线上化单数',
                        'prop': 'ontrackCntTotal',
                        'width': '140px'
                    },
                    {
                        'label': '上月出勤总车辆数',
                        'prop': 'monthActivityCar',
                        'width': '140px'
                    },
                    {
                        'label': '上月高中活车辆数',
                        'prop': 'monthHighActivityCar',
                        'width': '140px'
                    },
                    {
                        'label': '运力稳定率(%)',
                        'prop': 'stabilityRateOfTransportationCapacity',
                        'width': '140px',
                        'info': '<div>运力稳定率=上月高中活车辆数/上月出勤总车辆数</div><div>取数来源：数据银行-运营分析-区域配送-运力活跃度明细；时间选择考核月份最后一天；根据车辆维度计算高、中活跃车辆数和出勤车辆数的占比。</div>'
                    },
                    {
                        'label': '运力稳定率得分',
                        'prop': 'stabilityRateOfTransportationCapacityScore',
                        'width': '120px'
                    },
                    {
                        'label': '减分项-客户投诉得分',
                        'prop': 'customerComplaintsScore',
                        'width': '150px'
                    },
                    {
                        'label': '加分项-客户表扬得分',
                        'prop': 'customerPraiseScore',
                        'width': '150px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '发文链接',
                        'prop': 'postingLink',
                        'width': '120px',
                        'type': 'link'
                    },
                    {
                        'label': '帮扶计划提交',
                        'prop': 'isSubmitHelpPlan',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px',
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '调整',
                        'size': 'small',
                        'event': 'performChange',
                        'ifHas': '/legalPerform-10',
                    },
                    {
                        'type': 'text',
                        'label': '驳回申诉',
                        'size': 'small',
                        'event': 'rejectAppeal',
                        'ifHas': '/legalPerform-20',
                    },
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/legalPerform-30',
                    },
                    {
                        'type': 'text',
                        'label': '查看帮扶计划',
                        'size': 'small',
                        'event': 'viewProject',
                        'ifHas': '/legalPerform-40',
                    },
                    {
                        'type': 'text',
                        'label': '提交帮扶计划',
                        'size': 'small',
                        'event': 'submitProject',
                        'ifHas': '/legalPerform-50',
                    },
                    // {
                    //     'type': 'text',
                    //     'label': '操作记录',
                    //     'size': 'small',
                    //     'event': 'record',
                    //     'ifHas': '/legalPerform-110',
                    // },
                    {
                        'type': 'text',
                        'label': '审批',
                        'size': 'small',
                        'event': 'approve',
                        'ifHas': '/legalPerform-150',
                    },
                    {
                        'type': 'text',
                        'label': '详情',
                        'size': 'small',
                        'event': 'detail',
                        'ifHas': '/legalPerform-120',
                    },
                ]
            },
            'companyClientTable': {
                'pageId': 'legal-perform-lsrm7',
                'searchId': 'legal-perform-lsrm7-sd',
                'leftOperation': true,
                'leftWidth': 250,
                'selectBtn': true,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'label': '内外部客户',
                        'prop': 'customerType',
                        'type': 'select',
                        'options': [
                            { label: '内部客户', value: '1' },
                            { label: '外部客户', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '全国排名(内外部)',
                        'prop': 'ranking',
                        'width': '170px',
                        'info': '分公司（内外部）层级下，全国供应商绩效排名，区分内部和外部客户两个维度'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：报表发车是否及时等于及时的所有TK单数求和</div><div>应发货数量：取该供应商要求发车时间在当月的所有运输单计数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-发车及时率明细</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：报表签收是否及时等于及时的所有TK单数求和</div><div>到货总数量：取该供应商要求签收时间在当月的所有运输单计数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：城配来自报表配送及时率/干线指标来自到货及时率</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：报表电子回单上传等于及时的所有TK单数求和</div><div>回单总数量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-回单全链路明细报表</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：该供应商的完好商品件数求和</div><div>货物总数量：取该供应商签收时间在当月的所有商品的件数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-异常签收明细报表</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '运力线上化率(%)',
                        'prop': 'onlineRateOfTransportationCapacity',
                        'width': '160px',
                        'info': '<div>运力线上化率=线上化单数/线上考核单数</div><div>线上化单数：取该供应商的所有正向订单，且发车，抵达，在途属于自动在线的TK单数求和</div><div>线上考核单数：取该供应商的所有正向订单，且发车，抵达，在途的所有TK单数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-订单自动化采集汇总表(仅限城配/配送业务数据/干线数据无此指标)</div>'
                    },
                    {
                        'label': '运力线上化率得分',
                        'prop': 'onlineRateOfTransportationCapacityScore',
                        'width': '140px'
                    },
                    {
                        'label': '线上考核单数',
                        'prop': 'ontrackAllCntTotal',
                        'width': '140px'
                    },
                    {
                        'label': '线上化单数',
                        'prop': 'ontrackCntTotal',
                        'width': '140px'
                    },
                    {
                        'label': '上月出勤总车辆数',
                        'prop': 'monthActivityCar',
                        'width': '140px'
                    },
                    {
                        'label': '上月高中活车辆数',
                        'prop': 'monthHighActivityCar',
                        'width': '140px'
                    },
                    {
                        'label': '运力稳定率(%)',
                        'prop': 'stabilityRateOfTransportationCapacity',
                        'width': '140px',
                        'info': '<div>运力稳定率=上月高中活车辆数/上月出勤总车辆数</div><div>取数来源：数据银行-运营分析-区域配送-运力活跃度明细；时间选择考核月份最后一天；根据车辆维度计算高、中活跃车辆数和出勤车辆数的占比。</div>'
                    },
                    {
                        'label': '运力稳定率得分',
                        'prop': 'stabilityRateOfTransportationCapacityScore',
                        'width': '120px'
                    },
                    {
                        'label': '减分项-客户投诉得分',
                        'prop': 'customerComplaintsScore',
                        'width': '150px'
                    },
                    {
                        'label': '加分项-客户表扬得分',
                        'prop': 'customerPraiseScore',
                        'width': '150px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '发文链接',
                        'prop': 'postingLink',
                        'width': '120px',
                        'type': 'link'
                    },
                    {
                        'label': '帮扶计划提交',
                        'prop': 'isSubmitHelpPlan',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px',
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '调整',
                        'size': 'small',
                        'event': 'performChange',
                        'ifHas': '/legalPerform-10',
                    },
                    {
                        'type': 'text',
                        'label': '驳回申诉',
                        'size': 'small',
                        'event': 'rejectAppeal',
                        'ifHas': '/legalPerform-20',
                    },
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/legalPerform-30',
                    },
                    {
                        'type': 'text',
                        'label': '查看帮扶计划',
                        'size': 'small',
                        'event': 'viewProject',
                        'ifHas': '/legalPerform-40',
                    },
                    {
                        'type': 'text',
                        'label': '提交帮扶计划',
                        'size': 'small',
                        'event': 'submitProject',
                        'ifHas': '/legalPerform-50',
                    },
                    // {
                    //     'type': 'text',
                    //     'label': '操作记录',
                    //     'size': 'small',
                    //     'event': 'record',
                    //     'ifHas': '/legalPerform-110',
                    // },
                    {
                        'type': 'text',
                        'label': '审批',
                        'size': 'small',
                        'event': 'approve',
                        'ifHas': '/legalPerform-150',
                    },
                    {
                        'type': 'text',
                        'label': '详情',
                        'size': 'small',
                        'event': 'detail',
                        'ifHas': '/legalPerform-120',
                    },
                ]
            },
            'businessTable': {
                'pageId': 'legal-perform-lsrm9',
                'searchId': 'legal-perform-lsrm9-sd',
                'leftOperation': true,
                'leftWidth': 250,
                'selectBtn': true,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '经营中心排名',
                        'prop': 'ranking',
                        'width': '120px',
                        'info': '经营中心层级下，对在同一个经营中心下运作的供应商绩效进行排名'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：报表发车是否及时等于及时的所有TK单数求和</div><div>应发货数量：取该供应商要求发车时间在当月的所有运输单计数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-发车及时率明细</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：报表签收是否及时等于及时的所有TK单数求和</div><div>到货总数量：取该供应商要求签收时间在当月的所有运输单计数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：城配来自报表配送及时率/干线指标来自到货及时率</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：报表电子回单上传等于及时的所有TK单数求和</div><div>回单总数量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-回单全链路明细报表</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：该供应商的完好商品件数求和</div><div>货物总数量：取该供应商签收时间在当月的所有商品的件数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-异常签收明细报表</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '运力线上化率(%)',
                        'prop': 'onlineRateOfTransportationCapacity',
                        'width': '160px',
                        'info': '<div>运力线上化率=线上化单数/线上考核单数</div><div>线上化单数：取该供应商的所有正向订单，且发车，抵达，在途属于自动在线的TK单数求和</div><div>线上考核单数：取该供应商的所有正向订单，且发车，抵达，在途的所有TK单数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-订单自动化采集汇总表(仅限城配/配送业务数据/干线数据无此指标)</div>'
                    },
                    {
                        'label': '运力线上化率得分',
                        'prop': 'onlineRateOfTransportationCapacityScore',
                        'width': '140px'
                    },
                    {
                        'label': '线上考核单数',
                        'prop': 'ontrackAllCntTotal',
                        'width': '140px'
                    },
                    {
                        'label': '线上化单数',
                        'prop': 'ontrackCntTotal',
                        'width': '140px'
                    },
                    {
                        'label': '上月出勤总车辆数',
                        'prop': 'monthActivityCar',
                        'width': '140px'
                    },
                    {
                        'label': '上月高中活车辆数',
                        'prop': 'monthHighActivityCar',
                        'width': '140px'
                    },
                    {
                        'label': '运力稳定率(%)',
                        'prop': 'stabilityRateOfTransportationCapacity',
                        'width': '140px',
                        'info': '<div>运力稳定率=上月高中活车辆数/上月出勤总车辆数</div><div>取数来源：数据银行-运营分析-区域配送-运力活跃度明细；时间选择考核月份最后一天；根据车辆维度计算高、中活跃车辆数和出勤车辆数的占比。</div>'
                    },
                    {
                        'label': '运力稳定率得分',
                        'prop': 'stabilityRateOfTransportationCapacityScore',
                        'width': '120px'
                    },
                    {
                        'label': '减分项-客户投诉得分',
                        'prop': 'customerComplaintsScore',
                        'width': '150px'
                    },
                    {
                        'label': '加分项-客户表扬得分',
                        'prop': 'customerPraiseScore',
                        'width': '150px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '发文链接',
                        'prop': 'postingLink',
                        'width': '120px',
                        'type': 'link'
                    },
                    {
                        'label': '帮扶计划提交',
                        'prop': 'isSubmitHelpPlan',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px',
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '调整',
                        'size': 'small',
                        'event': 'performChange',
                        'ifHas': '/legalPerform-10',
                    },
                    {
                        'type': 'text',
                        'label': '驳回申诉',
                        'size': 'small',
                        'event': 'rejectAppeal',
                        'ifHas': '/legalPerform-20',
                    },
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/legalPerform-30',
                    },
                    {
                        'type': 'text',
                        'label': '查看帮扶计划',
                        'size': 'small',
                        'event': 'viewProject',
                        'ifHas': '/legalPerform-40',
                    },
                    {
                        'type': 'text',
                        'label': '提交帮扶计划',
                        'size': 'small',
                        'event': 'submitProject',
                        'ifHas': '/legalPerform-50',
                    },
                    // {
                    //     'type': 'text',
                    //     'label': '操作记录',
                    //     'size': 'small',
                    //     'event': 'record',
                    //     'ifHas': '/legalPerform-110',
                    // },
                    {
                        'type': 'text',
                        'label': '审批',
                        'size': 'small',
                        'event': 'approve',
                        'ifHas': '/legalPerform-150',
                    },
                    {
                        'type': 'text',
                        'label': '详情',
                        'size': 'small',
                        'event': 'detail',
                        'ifHas': '/legalPerform-120',
                    },
                ]
            },
            'businessClientTable': {
                'pageId': 'legal-perform-lsrm10',
                'searchId': 'legal-perform-lsrm10-sd',
                'leftOperation': true,
                'leftWidth': 250,
                'selectBtn': true,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'label': '内外部客户',
                        'prop': 'customerType',
                        'type': 'select',
                        'options': [
                            { label: '内部客户', value: '1' },
                            { label: '外部客户', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '经营中心排名(内外部)',
                        'prop': 'ranking',
                        'width': '170px',
                        'info': '经营中心（内外部）层级下，对在同一个经营中心运作的供应商绩效进行排名，排名区分内部和外部客户'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：报表发车是否及时等于及时的所有TK单数求和</div><div>应发货数量：取该供应商要求发车时间在当月的所有运输单计数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-发车及时率明细</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：报表签收是否及时等于及时的所有TK单数求和</div><div>到货总数量：取该供应商要求签收时间在当月的所有运输单计数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：城配来自报表配送及时率/干线指标来自到货及时率</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：报表电子回单上传等于及时的所有TK单数求和</div><div>回单总数量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-回单全链路明细报表</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：该供应商的完好商品件数求和</div><div>货物总数量：取该供应商签收时间在当月的所有商品的件数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-异常签收明细报表</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '运力线上化率(%)',
                        'prop': 'onlineRateOfTransportationCapacity',
                        'width': '160px',
                        'info': '<div>运力线上化率=线上化单数/线上考核单数</div><div>线上化单数：取该供应商的所有正向订单，且发车，抵达，在途属于自动在线的TK单数求和</div><div>线上考核单数：取该供应商的所有正向订单，且发车，抵达，在途的所有TK单数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-订单自动化采集汇总表(仅限城配/配送业务数据/干线数据无此指标)</div>'
                    },
                    {
                        'label': '运力线上化率得分',
                        'prop': 'onlineRateOfTransportationCapacityScore',
                        'width': '140px'
                    },
                    {
                        'label': '线上考核单数',
                        'prop': 'ontrackAllCntTotal',
                        'width': '140px'
                    },
                    {
                        'label': '线上化单数',
                        'prop': 'ontrackCntTotal',
                        'width': '140px'
                    },
                    {
                        'label': '上月出勤总车辆数',
                        'prop': 'monthActivityCar',
                        'width': '140px'
                    },
                    {
                        'label': '上月高中活车辆数',
                        'prop': 'monthHighActivityCar',
                        'width': '140px'
                    },
                    {
                        'label': '运力稳定率(%)',
                        'prop': 'stabilityRateOfTransportationCapacity',
                        'width': '140px',
                        'info': '<div>运力稳定率=上月高中活车辆数/上月出勤总车辆数</div><div>取数来源：数据银行-运营分析-区域配送-运力活跃度明细；时间选择考核月份最后一天；根据车辆维度计算高、中活跃车辆数和出勤车辆数的占比。</div>'
                    },
                    {
                        'label': '运力稳定率得分',
                        'prop': 'stabilityRateOfTransportationCapacityScore',
                        'width': '120px'
                    },
                    {
                        'label': '减分项-客户投诉得分',
                        'prop': 'customerComplaintsScore',
                        'width': '150px'
                    },
                    {
                        'label': '加分项-客户表扬得分',
                        'prop': 'customerPraiseScore',
                        'width': '150px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '发文链接',
                        'prop': 'postingLink',
                        'width': '120px',
                        'type': 'link'
                    },
                    {
                        'label': '帮扶计划提交',
                        'prop': 'isSubmitHelpPlan',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px',
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '调整',
                        'size': 'small',
                        'event': 'performChange',
                        'ifHas': '/legalPerform-10',
                    },
                    {
                        'type': 'text',
                        'label': '驳回申诉',
                        'size': 'small',
                        'event': 'rejectAppeal',
                        'ifHas': '/legalPerform-20',
                    },
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/legalPerform-30',
                    },
                    {
                        'type': 'text',
                        'label': '查看帮扶计划',
                        'size': 'small',
                        'event': 'viewProject',
                        'ifHas': '/legalPerform-40',
                    },
                    {
                        'type': 'text',
                        'label': '提交帮扶计划',
                        'size': 'small',
                        'event': 'submitProject',
                        'ifHas': '/legalPerform-50',
                    },
                    // {
                    //     'type': 'text',
                    //     'label': '操作记录',
                    //     'size': 'small',
                    //     'event': 'record',
                    //     'ifHas': '/legalPerform-110',
                    // },
                    {
                        'type': 'text',
                        'label': '审批',
                        'size': 'small',
                        'event': 'approve',
                        'ifHas': '/legalPerform-150',
                    },
                    {
                        'type': 'text',
                        'label': '详情',
                        'size': 'small',
                        'event': 'detail',
                        'ifHas': '/legalPerform-120',
                    },
                ]
            },
            'platformTable': {
                'pageId': 'legal-perform-lsrm2',
                'searchId': 'legal-perform-lsrm2-sd',
                'leftOperation': true,
                'leftWidth': 250,
                'selectBtn': true,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'prop': 'siteName',
                        'label': '服务平台',
                        'width': '150px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '分公司内排名',
                        'prop': 'ranking',
                        'width': '120px',
                        'info': '服务平台层级下，同一分公司供应商绩效排名'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：报表发车是否及时等于及时的所有TK单数求和</div><div>应发货数量：取该供应商要求发车时间在当月的所有运输单计数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-发车及时率明细</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：报表签收是否及时等于及时的所有TK单数求和</div><div>到货总数量：取该供应商要求签收时间在当月的所有运输单计数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：城配来自报表配送及时率/干线指标来自到货及时率</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：报表电子回单上传等于及时的所有TK单数求和</div><div>回单总数量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-回单全链路明细报表</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：该供应商的完好商品件数求和</div><div>货物总数量：取该供应商签收时间在当月的所有商品的件数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-异常签收明细报表</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '运力线上化率(%)',
                        'prop': 'onlineRateOfTransportationCapacity',
                        'width': '160px',
                        'info': '<div>运力线上化率=线上化单数/线上考核单数</div><div>线上化单数：取该供应商的所有正向订单，且发车，抵达，在途属于自动在线的TK单数求和</div><div>线上考核单数：取该供应商的所有正向订单，且发车，抵达，在途的所有TK单数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-订单自动化采集汇总表(仅限城配/配送业务数据/干线数据无此指标)</div>'
                    },
                    {
                        'label': '运力线上化率得分',
                        'prop': 'onlineRateOfTransportationCapacityScore',
                        'width': '140px'
                    },
                    {
                        'label': '线上考核单数',
                        'prop': 'ontrackAllCntTotal',
                        'width': '140px'
                    },
                    {
                        'label': '线上化单数',
                        'prop': 'ontrackCntTotal',
                        'width': '140px'
                    },
                    {
                        'label': '上月出勤总车辆数',
                        'prop': 'monthActivityCar',
                        'width': '140px'
                    },
                    {
                        'label': '上月高中活车辆数',
                        'prop': 'monthHighActivityCar',
                        'width': '140px'
                    },
                    {
                        'label': '运力稳定率(%)',
                        'prop': 'stabilityRateOfTransportationCapacity',
                        'width': '140px',
                        'info': '<div>运力稳定率=上月高中活车辆数/上月出勤总车辆数</div><div>取数来源：数据银行-运营分析-区域配送-运力活跃度明细；时间选择考核月份最后一天；根据车辆维度计算高、中活跃车辆数和出勤车辆数的占比。</div>'
                    },
                    {
                        'label': '运力稳定率得分',
                        'prop': 'stabilityRateOfTransportationCapacityScore',
                        'width': '120px'
                    },
                    {
                        'label': '减分项-客户投诉得分',
                        'prop': 'customerComplaintsScore',
                        'width': '150px'
                    },
                    {
                        'label': '加分项-客户表扬得分',
                        'prop': 'customerPraiseScore',
                        'width': '150px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '发文链接',
                        'prop': 'postingLink',
                        'width': '120px',
                        'type': 'link'
                    },
                    {
                        'label': '帮扶计划提交',
                        'prop': 'isSubmitHelpPlan',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px',
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '调整',
                        'size': 'small',
                        'event': 'performChange',
                        'ifHas': '/legalPerform-10',
                    },
                    {
                        'type': 'text',
                        'label': '驳回申诉',
                        'size': 'small',
                        'event': 'rejectAppeal',
                        'ifHas': '/legalPerform-20',
                    },
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/legalPerform-30',
                    },
                    {
                        'type': 'text',
                        'label': '查看帮扶计划',
                        'size': 'small',
                        'event': 'viewProject',
                        'ifHas': '/legalPerform-40',
                    },
                    {
                        'type': 'text',
                        'label': '提交帮扶计划',
                        'size': 'small',
                        'event': 'submitProject',
                        'ifHas': '/legalPerform-50',
                    },
                    // {
                    //     'type': 'text',
                    //     'label': '操作记录',
                    //     'size': 'small',
                    //     'event': 'record',
                    //     'ifHas': '/legalPerform-110',
                    // },
                    {
                        'type': 'text',
                        'label': '审批',
                        'size': 'small',
                        'event': 'approve',
                    },
                    {
                        'type': 'text',
                        'label': '详情',
                        'size': 'small',
                        'event': 'detail',
                        'ifHas': '/legalPerform-120',
                    },
                ]
            },
            'clientTable': {
                'pageId': 'legal-perform-lsrm3',
                'searchId': 'legal-perform-lsrm3-sd',
                'leftOperation': true,
                'leftWidth': 250,
                'selectBtn': true,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'prop': 'siteName',
                        'label': '服务平台',
                        'width': '150px'
                    },
                    {
                        'label': '内外部客户',
                        'prop': 'customerType',
                        'type': 'select',
                        'options': [
                            { label: '内部客户', value: '1' },
                            { label: '外部客户', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '服务平台内排名',
                        'prop': 'ranking',
                        'width': '160px',
                        'info': '内外部客户层级下，同一服务平台供应商绩效排名，排名区分内部和外部客户'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：报表发车是否及时等于及时的所有TK单数求和</div><div>应发货数量：取该供应商要求发车时间在当月的所有运输单计数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-发车及时率明细</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：报表签收是否及时等于及时的所有TK单数求和</div><div>到货总数量：取该供应商要求签收时间在当月的所有运输单计数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：城配来自报表配送及时率/干线指标来自到货及时率</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：报表电子回单上传等于及时的所有TK单数求和</div><div>回单总数量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-回单全链路明细报表</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：该供应商的完好商品件数求和</div><div>货物总数量：取该供应商签收时间在当月的所有商品的件数求和</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-异常签收明细报表</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '运力线上化率(%)',
                        'prop': 'onlineRateOfTransportationCapacity',
                        'width': '160px',
                        'info': '<div>运力线上化率=线上化单数/线上考核单数</div><div>线上化单数：取该供应商的所有正向订单，且发车，抵达，在途属于自动在线的TK单数求和</div><div>线上考核单数：取该供应商的所有正向订单，且发车，抵达，在途的所有TK单数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-订单自动化采集汇总表(仅限城配/配送业务数据/干线数据无此指标)</div>'
                    },
                    {
                        'label': '运力线上化率得分',
                        'prop': 'onlineRateOfTransportationCapacityScore',
                        'width': '140px'
                    },
                    {
                        'label': '线上考核单数',
                        'prop': 'ontrackAllCntTotal',
                        'width': '140px'
                    },
                    {
                        'label': '线上化单数',
                        'prop': 'ontrackCntTotal',
                        'width': '140px'
                    },
                    {
                        'label': '上月出勤总车辆数',
                        'prop': 'monthActivityCar',
                        'width': '140px'
                    },
                    {
                        'label': '上月高中活车辆数',
                        'prop': 'monthHighActivityCar',
                        'width': '140px'
                    },
                    {
                        'label': '运力稳定率(%)',
                        'prop': 'stabilityRateOfTransportationCapacity',
                        'width': '140px',
                        'info': '<div>运力稳定率=上月高中活车辆数/上月出勤总车辆数</div><div>取数来源：数据银行-运营分析-区域配送-运力活跃度明细；时间选择考核月份最后一天；根据车辆维度计算高、中活跃车辆数和出勤车辆数的占比。</div>'
                    },
                    {
                        'label': '运力稳定率得分',
                        'prop': 'stabilityRateOfTransportationCapacityScore',
                        'width': '120px'
                    },
                    {
                        'label': '减分项-客户投诉得分',
                        'prop': 'customerComplaintsScore',
                        'width': '150px'
                    },
                    {
                        'label': '加分项-客户表扬得分',
                        'prop': 'customerPraiseScore',
                        'width': '150px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '发文链接',
                        'prop': 'postingLink',
                        'width': '120px',
                        'type': 'link'
                    },
                    {
                        'label': '帮扶计划提交',
                        'prop': 'isSubmitHelpPlan',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px',
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '调整',
                        'size': 'small',
                        'event': 'performChange',
                        'ifHas': '/legalPerform-10',
                    },
                    {
                        'type': 'text',
                        'label': '驳回申诉',
                        'size': 'small',
                        'event': 'rejectAppeal',
                        'ifHas': '/legalPerform-20',
                    },
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/legalPerform-30',
                    },
                    {
                        'type': 'text',
                        'label': '查看帮扶计划',
                        'size': 'small',
                        'event': 'viewProject',
                        'ifHas': '/legalPerform-40',
                    },
                    {
                        'type': 'text',
                        'label': '提交帮扶计划',
                        'size': 'small',
                        'event': 'submitProject',
                        'ifHas': '/legalPerform-50',
                    },
                    // {
                    //     'type': 'text',
                    //     'label': '操作记录',
                    //     'size': 'small',
                    //     'event': 'record',
                    //     'ifHas': '/legalPerform-110',
                    // },
                    {
                        'type': 'text',
                        'label': '审批',
                        'size': 'small',
                        'event': 'approve',
                    },
                    {
                        'type': 'text',
                        'label': '详情',
                        'size': 'small',
                        'event': 'detail',
                        'ifHas': '/legalPerform-120',
                    },
                ]
            },
        },
        'delivery_new': delivery_new_lsrm,
        'transport': {
            'companyTable': {
                'pageId': 'legal-perform-lsrm4',
                'searchId': 'legal-perform-lsrm4-sd',
                'leftOperation': true,
                'leftWidth': 250,
                'selectBtn': true,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：零担干线专司，生产物流专司</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '日度累计得分',
                        'prop': 'dailyCumulativeScore',
                        'width': '120px',
                    },
                    {
                        'label': '日度累计排名',
                        'prop': 'dailyCumulativeRanking',
                        'width': '120px',
                        'info': '每日更新当月1日到前一日的累计得分和排名',
                    },
                    {
                        label: '日度绩效等级',
                        prop: 'dailyPerformanceGrade',
                        width: '120px',
                        type: 'select',
                        optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        options: [],
                    },
                    {
                        'label': '全国排名',
                        'prop': 'ranking',
                        'width': '120px',
                        'info': '分公司层级下，全国供应商绩效排名'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：报表发车是否及时等于及时的所有TK单数求和</div><div>应发货数量：取该供应商要求发车时间在当月的所有运输单计数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-报表明细-仓干业务-发货及时率明细</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：报表签收是否及时等于及时的所有TK单数求和</div><div>到货总数量：取该供应商要求签收时间在当月的所有运输单计数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-到车及时率明细</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：报表电子回单上传等于及时的所有TK单数求和</div><div>回单总数量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-报表明细-仓干业务-回单及时率明细</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：该供应商的完好商品件数求和</div><div>货物总数量：取该供应商签收时间在当月的所有商品的件数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-异常签收明细报表</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '罚扣金额',
                        'prop': 'penaltyDeductionAmount',
                        'width': '120px',
                    },
                    {
                        'label': '发文链接',
                        'prop': 'postingLink',
                        'width': '120px',
                        'type': 'link'
                    },
                    {
                        'label': '帮扶计划提交',
                        'prop': 'isSubmitHelpPlan',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px',
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '调整',
                        'size': 'small',
                        'event': 'performChange',
                        'ifHas': '/legalPerform-10',
                    },
                    {
                        'type': 'text',
                        'label': '驳回申诉',
                        'size': 'small',
                        'event': 'rejectAppeal',
                        'ifHas': '/legalPerform-20',
                    },
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/legalPerform-30',
                    },
                    {
                        'type': 'text',
                        'label': '查看帮扶计划',
                        'size': 'small',
                        'event': 'viewProject',
                        'ifHas': '/legalPerform-40',
                    },
                    {
                        'type': 'text',
                        'label': '提交帮扶计划',
                        'size': 'small',
                        'event': 'submitProject',
                        'ifHas': '/legalPerform-50',
                    },
                    // {
                    //     'type': 'text',
                    //     'label': '操作记录',
                    //     'size': 'small',
                    //     'event': 'record',
                    //     'ifHas': '/legalPerform-110',
                    // },
                    {
                        'type': 'text',
                        'label': '审批',
                        'size': 'small',
                        'event': 'approve',
                    },
                    {
                        'type': 'text',
                        'label': '详情',
                        'size': 'small',
                        'event': 'detail',
                    },
                ]
            },
            'companyClientTable': {
                'pageId': 'legal-perform-lsrm8',
                'searchId': 'legal-perform-lsrm8-sd',
                'leftOperation': true,
                'leftWidth': 250,
                'selectBtn': true,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'label': '内外部客户',
                        'prop': 'customerType',
                        'type': 'select',
                        'options': [
                            { label: '内部客户', value: '1' },
                            { label: '外部客户', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：零担干线专司，生产物流专司</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '日度累计得分',
                        'prop': 'dailyCumulativeScore',
                        'width': '120px',
                    },
                    {
                        'label': '日度累计排名',
                        'prop': 'dailyCumulativeRanking',
                        'width': '120px',
                        'info': '每日更新当月1日到前一日的累计得分和排名',
                    },
                    {
                        label: '日度绩效等级',
                        prop: 'dailyPerformanceGrade',
                        width: '120px',
                        type: 'select',
                        optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        options: [],
                    },
                    {
                        'label': '全国排名(内外部)',
                        'prop': 'ranking',
                        'width': '170px',
                        'info': '分公司（内外部）层级下，全国供应商绩效排名，区分内部和外部客户两个维度'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：报表发车是否及时等于及时的所有TK单数求和</div><div>应发货数量：取该供应商要求发车时间在当月的所有运输单计数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-报表明细-仓干业务-发货及时率明细</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：报表签收是否及时等于及时的所有TK单数求和</div><div>到货总数量：取该供应商要求签收时间在当月的所有运输单计数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-到车及时率明细</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：报表电子回单上传等于及时的所有TK单数求和</div><div>回单总数量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-报表明细-仓干业务-回单及时率明细</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：该供应商的完好商品件数求和</div><div>货物总数量：取该供应商签收时间在当月的所有商品的件数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-异常签收明细报表</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '发文链接',
                        'prop': 'postingLink',
                        'width': '120px',
                        'type': 'link'
                    },
                    {
                        'label': '帮扶计划提交',
                        'prop': 'isSubmitHelpPlan',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px',
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '调整',
                        'size': 'small',
                        'event': 'performChange',
                        'ifHas': '/legalPerform-10',
                    },
                    {
                        'type': 'text',
                        'label': '驳回申诉',
                        'size': 'small',
                        'event': 'rejectAppeal',
                        'ifHas': '/legalPerform-20',
                    },
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/legalPerform-30',
                    },
                    {
                        'type': 'text',
                        'label': '查看帮扶计划',
                        'size': 'small',
                        'event': 'viewProject',
                        'ifHas': '/legalPerform-40',
                    },
                    {
                        'type': 'text',
                        'label': '提交帮扶计划',
                        'size': 'small',
                        'event': 'submitProject',
                        'ifHas': '/legalPerform-50',
                    },
                    // {
                    //     'type': 'text',
                    //     'label': '操作记录',
                    //     'size': 'small',
                    //     'event': 'record',
                    //     'ifHas': '/legalPerform-110',
                    // },
                    {
                        'type': 'text',
                        'label': '审批',
                        'size': 'small',
                        'event': 'approve',
                    },
                    {
                        'type': 'text',
                        'label': '详情',
                        'size': 'small',
                        'event': 'detail',
                    },
                ]
            },
            'businessTable': {
                'pageId': 'legal-perform-lsrm11',
                'searchId': 'legal-perform-lsrm11-sd',
                'leftOperation': true,
                'leftWidth': 250,
                'selectBtn': true,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：零担干线专司，生产物流专司</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '日度累计得分',
                        'prop': 'dailyCumulativeScore',
                        'width': '120px',
                    },
                    {
                        'label': '日度累计排名',
                        'prop': 'dailyCumulativeRanking',
                        'width': '120px',
                        'info': '每日更新当月1日到前一日的累计得分和排名',
                    },
                    {
                        label: '日度绩效等级',
                        prop: 'dailyPerformanceGrade',
                        width: '120px',
                        type: 'select',
                        optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        options: [],
                    },
                    {
                        'label': '经营中心排名',
                        'prop': 'ranking',
                        'width': '120px',
                        'info': '经营中心层级下，对在同一个经营中心下运作的供应商绩效进行排名'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：报表发车是否及时等于及时的所有TK单数求和</div><div>应发货数量：取该供应商要求发车时间在当月的所有运输单计数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-报表明细-仓干业务-发货及时率明细</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：报表签收是否及时等于及时的所有TK单数求和</div><div>到货总数量：取该供应商要求签收时间在当月的所有运输单计数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-到车及时率明细</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：报表电子回单上传等于及时的所有TK单数求和</div><div>回单总数量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-报表明细-仓干业务-回单及时率明细</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：该供应商的完好商品件数求和</div><div>货物总数量：取该供应商签收时间在当月的所有商品的件数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-异常签收明细报表</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '罚扣金额',
                        'prop': 'penaltyDeductionAmount',
                        'width': '120px',
                    },
                    {
                        'label': '发文链接',
                        'prop': 'postingLink',
                        'width': '120px',
                        'type': 'link'
                    },
                    {
                        'label': '帮扶计划提交',
                        'prop': 'isSubmitHelpPlan',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px',
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '调整',
                        'size': 'small',
                        'event': 'performChange',
                        'ifHas': '/legalPerform-10',
                    },
                    {
                        'type': 'text',
                        'label': '驳回申诉',
                        'size': 'small',
                        'event': 'rejectAppeal',
                        'ifHas': '/legalPerform-20',
                    },
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/legalPerform-30',
                    },
                    {
                        'type': 'text',
                        'label': '查看帮扶计划',
                        'size': 'small',
                        'event': 'viewProject',
                        'ifHas': '/legalPerform-40',
                    },
                    {
                        'type': 'text',
                        'label': '提交帮扶计划',
                        'size': 'small',
                        'event': 'submitProject',
                        'ifHas': '/legalPerform-50',
                    },
                    // {
                    //     'type': 'text',
                    //     'label': '操作记录',
                    //     'size': 'small',
                    //     'event': 'record',
                    //     'ifHas': '/legalPerform-110',
                    // },
                    {
                        'type': 'text',
                        'label': '审批',
                        'size': 'small',
                        'event': 'approve',
                    },
                    {
                        'type': 'text',
                        'label': '详情',
                        'size': 'small',
                        'event': 'detail',
                    },
                ]
            },
            'businessClientTable': {
                'pageId': 'legal-perform-lsrm12',
                'searchId': 'legal-perform-lsrm12-sd',
                'leftOperation': true,
                'leftWidth': 250,
                'selectBtn': true,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'label': '内外部客户',
                        'prop': 'customerType',
                        'type': 'select',
                        'options': [
                            { label: '内部客户', value: '1' },
                            { label: '外部客户', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：零担干线专司，生产物流专司</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '日度累计得分',
                        'prop': 'dailyCumulativeScore',
                        'width': '120px',
                    },
                    {
                        'label': '日度累计排名',
                        'prop': 'dailyCumulativeRanking',
                        'width': '120px',
                        'info': '每日更新当月1日到前一日的累计得分和排名',
                    },
                    {
                        label: '日度绩效等级',
                        prop: 'dailyPerformanceGrade',
                        width: '120px',
                        type: 'select',
                        optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        options: [],
                    },
                    {
                        'label': '经营中心排名(内外部)',
                        'prop': 'ranking',
                        'width': '170px',
                        'info': '经营中心（内外部）层级下，对在同一个经营中心运作的供应商绩效进行排名，排名区分内部和外部客户'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：报表发车是否及时等于及时的所有TK单数求和</div><div>应发货数量：取该供应商要求发车时间在当月的所有运输单计数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-报表明细-仓干业务-发货及时率明细</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：报表签收是否及时等于及时的所有TK单数求和</div><div>到货总数量：取该供应商要求签收时间在当月的所有运输单计数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-到车及时率明细</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：报表电子回单上传等于及时的所有TK单数求和</div><div>回单总数量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-报表明细-仓干业务-回单及时率明细</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：该供应商的完好商品件数求和</div><div>货物总数量：取该供应商签收时间在当月的所有商品的件数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-异常签收明细报表</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '发文链接',
                        'prop': 'postingLink',
                        'width': '120px',
                        'type': 'link'
                    },
                    {
                        'label': '帮扶计划提交',
                        'prop': 'isSubmitHelpPlan',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px',
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '调整',
                        'size': 'small',
                        'event': 'performChange',
                        'ifHas': '/legalPerform-10',
                    },
                    {
                        'type': 'text',
                        'label': '驳回申诉',
                        'size': 'small',
                        'event': 'rejectAppeal',
                        'ifHas': '/legalPerform-20',
                    },
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/legalPerform-30',
                    },
                    {
                        'type': 'text',
                        'label': '查看帮扶计划',
                        'size': 'small',
                        'event': 'viewProject',
                        'ifHas': '/legalPerform-40',
                    },
                    {
                        'type': 'text',
                        'label': '提交帮扶计划',
                        'size': 'small',
                        'event': 'submitProject',
                        'ifHas': '/legalPerform-50',
                    },
                    // {
                    //     'type': 'text',
                    //     'label': '操作记录',
                    //     'size': 'small',
                    //     'event': 'record',
                    //     'ifHas': '/legalPerform-110',
                    // },
                    {
                        'type': 'text',
                        'label': '审批',
                        'size': 'small',
                        'event': 'approve',
                    },
                    {
                        'type': 'text',
                        'label': '详情',
                        'size': 'small',
                        'event': 'detail',
                    },
                ]
            },
            'platformTable': {
                'pageId': 'legal-perform-lsrm5',
                'searchId': 'legal-perform-lsrm5-sd',
                'leftOperation': true,
                'leftWidth': 250,
                'selectBtn': true,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'prop': 'siteName',
                        'label': '服务平台',
                        'width': '150px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：零担干线专司，生产物流专司</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '日度累计得分',
                        'prop': 'dailyCumulativeScore',
                        'width': '120px',
                    },
                    {
                        'label': '日度累计排名',
                        'prop': 'dailyCumulativeRanking',
                        'width': '120px',
                        'info': '每日更新当月1日到前一日的累计得分和排名',
                    },
                    {
                        label: '日度绩效等级',
                        prop: 'dailyPerformanceGrade',
                        width: '120px',
                        type: 'select',
                        optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        options: [],
                    },
                    {
                        'label': '分公司内排名',
                        'prop': 'ranking',
                        'width': '120px',
                        'info': '服务平台层级下，同一分公司供应商绩效排名'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：报表发车是否及时等于及时的所有TK单数求和</div><div>应发货数量：取该供应商要求发车时间在当月的所有运输单计数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-报表明细-仓干业务-发货及时率明细</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：报表签收是否及时等于及时的所有TK单数求和</div><div>到货总数量：取该供应商要求签收时间在当月的所有运输单计数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-到车及时率明细</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：报表电子回单上传等于及时的所有TK单数求和</div><div>回单总数量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-报表明细-仓干业务-回单及时率明细</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：该供应商的完好商品件数求和</div><div>货物总数量：取该供应商签收时间在当月的所有商品的件数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-异常签收明细报表</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '发文链接',
                        'prop': 'postingLink',
                        'width': '120px',
                        'type': 'link'
                    },
                    {
                        'label': '帮扶计划提交',
                        'prop': 'isSubmitHelpPlan',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px',
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '调整',
                        'size': 'small',
                        'event': 'performChange',
                        'ifHas': '/legalPerform-10',
                    },
                    {
                        'type': 'text',
                        'label': '驳回申诉',
                        'size': 'small',
                        'event': 'rejectAppeal',
                        'ifHas': '/legalPerform-20',
                    },
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/legalPerform-30',
                    },
                    {
                        'type': 'text',
                        'label': '查看帮扶计划',
                        'size': 'small',
                        'event': 'viewProject',
                        'ifHas': '/legalPerform-40',
                    },
                    {
                        'type': 'text',
                        'label': '提交帮扶计划',
                        'size': 'small',
                        'event': 'submitProject',
                        'ifHas': '/legalPerform-50',
                    },
                    // {
                    //     'type': 'text',
                    //     'label': '操作记录',
                    //     'size': 'small',
                    //     'event': 'record',
                    //     'ifHas': '/legalPerform-110',
                    // },
                    {
                        'type': 'text',
                        'label': '审批',
                        'size': 'small',
                        'event': 'approve',
                    },
                    {
                        'type': 'text',
                        'label': '详情',
                        'size': 'small',
                        'event': 'detail',
                    },
                ]
            },
            'clientTable': {
                'pageId': 'legal-perform-lsrm6',
                'searchId': 'legal-perform-lsrm6-sd',
                'leftOperation': true,
                'leftWidth': 250,
                'selectBtn': true,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'prop': 'siteName',
                        'label': '服务平台',
                        'width': '150px'
                    },
                    {
                        'label': '内外部客户',
                        'prop': 'customerType',
                        'type': 'select',
                        'options': [
                            { label: '内部客户', value: '1' },
                            { label: '外部客户', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：零担干线专司，生产物流专司</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '日度累计得分',
                        'prop': 'dailyCumulativeScore',
                        'width': '120px',
                    },
                    {
                        'label': '日度累计排名',
                        'prop': 'dailyCumulativeRanking',
                        'width': '120px',
                        'info': '每日更新当月1日到前一日的累计得分和排名',
                    },
                    {
                        label: '日度绩效等级',
                        prop: 'dailyPerformanceGrade',
                        width: '120px',
                        type: 'select',
                        optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        options: [],
                    },
                    {
                        'label': '服务平台内排名',
                        'prop': 'ranking',
                        'width': '160px',
                        'info': '内外部客户层级下，同一服务平台供应商绩效排名，排名区分内部和外部客户'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：报表发车是否及时等于及时的所有TK单数求和</div><div>应发货数量：取该供应商要求发车时间在当月的所有运输单计数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-报表明细-仓干业务-发货及时率明细</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：报表签收是否及时等于及时的所有TK单数求和</div><div>到货总数量：取该供应商要求签收时间在当月的所有运输单计数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-到车及时率明细</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：报表电子回单上传等于及时的所有TK单数求和</div><div>回单总数量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-报表明细-仓干业务-回单及时率明细</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：该供应商的完好商品件数求和</div><div>货物总数量：取该供应商签收时间在当月的所有商品的件数求和</div><div>专司限制：零担干线专司，生产物流专司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：运营分析-订单品质-异常签收明细报表</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '发文链接',
                        'prop': 'postingLink',
                        'width': '120px',
                        'type': 'link'
                    },
                    {
                        'label': '帮扶计划提交',
                        'prop': 'isSubmitHelpPlan',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px',
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '调整',
                        'size': 'small',
                        'event': 'performChange',
                        'ifHas': '/legalPerform-10',
                    },
                    {
                        'type': 'text',
                        'label': '驳回申诉',
                        'size': 'small',
                        'event': 'rejectAppeal',
                        'ifHas': '/legalPerform-20',
                    },
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/legalPerform-30',
                    },
                    {
                        'type': 'text',
                        'label': '查看帮扶计划',
                        'size': 'small',
                        'event': 'viewProject',
                        'ifHas': '/legalPerform-40',
                    },
                    {
                        'type': 'text',
                        'label': '提交帮扶计划',
                        'size': 'small',
                        'event': 'submitProject',
                        'ifHas': '/legalPerform-50',
                    },
                    // {
                    //     'type': 'text',
                    //     'label': '操作记录',
                    //     'size': 'small',
                    //     'event': 'record',
                    //     'ifHas': '/legalPerform-110',
                    // },
                    {
                        'type': 'text',
                        'label': '审批',
                        'size': 'small',
                        'event': 'approve',
                    },
                    {
                        'type': 'text',
                        'label': '详情',
                        'size': 'small',
                        'event': 'detail',
                        'ifHas': '/legalPerform-120',
                    },
                ]
            },
        },
    },
    'lsp': {
        'delivery': {
            'companyTable': {
                'pageId': 'legal-perform-lsp1',
                'searchId': 'legal-perform-lsp1-sd',
                'leftOperation': true,
                'leftWidth': 200,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：要求发车时间内发车的运输单数量</div><div>应发货数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：要求签收时间内签收的运输单数量</div><div>到货总数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：要求当月回单上传时间内上传的运输单数量</div><div>回单总数量：该供应商要求当月回单上传的所有运输单数量。</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：当月运输完好商品件数求和</div><div>货物总数量：该供应商当月运输所有商品的件数求和</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '运力线上化率(%)',
                        'prop': 'onlineRateOfTransportationCapacity',
                        'width': '160px',
                        'info': '<div>运力线上化率=线上化单数/线上考核单数</div><div>线上化单数：取该供应商的所有正向订单，且发车，抵达，在途属于自动在线的TK单数求和</div><div>线上考核单数：取该供应商的所有正向订单，且发车，抵达，在途的所有TK单数求和。</div>'
                    },
                    {
                        'label': '运力线上化率得分',
                        'prop': 'onlineRateOfTransportationCapacityScore',
                        'width': '140px'
                    },
                    {
                        'label': '运力稳定率(%)',
                        'prop': 'stabilityRateOfTransportationCapacity',
                        'width': '140px',
                        'info': '<div>运力稳定率=上月高中活车辆数/上月出勤总车辆数</div>'
                    },
                    {
                        'label': '运力稳定率得分',
                        'prop': 'stabilityRateOfTransportationCapacityScore',
                        'width': '120px'
                    },
                    {
                        'label': '减分项-客户投诉得分',
                        'prop': 'customerComplaintsScore',
                        'width': '150px'
                    },
                    {
                        'label': '加分项-客户表扬得分',
                        'prop': 'customerPraiseScore',
                        'width': '150px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '申诉期截止时间',
                        'prop': 'appealDeadlingTime',
                        'width': '120px'
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/lsrm/legalPerform-30'
                    },
                    {
                        'type': 'text',
                        'label': '确认绩效',
                        'size': 'small',
                        'event': 'confirmPerform',
                        'ifHas': '/lsrm/legalPerform-10'
                    },
                    {
                        'type': 'text',
                        'label': '申诉',
                        'size': 'small',
                        'event': 'appeal',
                        'ifHas': '/lsrm/legalPerform-20'
                    },
                ]
            },
            'companyClientTable': {
                'pageId': 'legal-perform-lsp7',
                'searchId': 'legal-perform-lsp7-sd',
                'leftOperation': true,
                'leftWidth': 200,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'label': '内外部客户',
                        'prop': 'customerType',
                        'type': 'select',
                        'options': [
                            { label: '内部客户', value: '1' },
                            { label: '外部客户', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：要求发车时间内发车的运输单数量</div><div>应发货数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：要求签收时间内签收的运输单数量</div><div>到货总数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：要求当月回单上传时间内上传的运输单数量</div><div>回单总数量：该供应商要求当月回单上传的所有运输单数量。</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：当月运输完好商品件数求和</div><div>货物总数量：该供应商当月运输所有商品的件数求和</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '运力线上化率(%)',
                        'prop': 'onlineRateOfTransportationCapacity',
                        'width': '160px',
                        'info': '<div>运力线上化率=线上化单数/线上考核单数</div><div>线上化单数：取该供应商的所有正向订单，且发车，抵达，在途属于自动在线的TK单数求和</div><div>线上考核单数：取该供应商的所有正向订单，且发车，抵达，在途的所有TK单数求和。</div>'
                    },
                    {
                        'label': '运力线上化率得分',
                        'prop': 'onlineRateOfTransportationCapacityScore',
                        'width': '140px'
                    },
                    {
                        'label': '运力稳定率(%)',
                        'prop': 'stabilityRateOfTransportationCapacity',
                        'width': '140px',
                        'info': '<div>运力稳定率=上月高中活车辆数/上月出勤总车辆数</div>'
                    },
                    {
                        'label': '运力稳定率得分',
                        'prop': 'stabilityRateOfTransportationCapacityScore',
                        'width': '120px'
                    },
                    {
                        'label': '减分项-客户投诉得分',
                        'prop': 'customerComplaintsScore',
                        'width': '150px'
                    },
                    {
                        'label': '加分项-客户表扬得分',
                        'prop': 'customerPraiseScore',
                        'width': '150px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '申诉期截止时间',
                        'prop': 'appealDeadlingTime',
                        'width': '120px'
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/lsrm/legalPerform-30'
                    },
                    {
                        'type': 'text',
                        'label': '确认绩效',
                        'size': 'small',
                        'event': 'confirmPerform',
                        'ifHas': '/lsrm/legalPerform-10'
                    },
                    {
                        'type': 'text',
                        'label': '申诉',
                        'size': 'small',
                        'event': 'appeal',
                        'ifHas': '/lsrm/legalPerform-20'
                    },
                ]
            },
            'businessTable': {
                'pageId': 'legal-perform-lsp13',
                'searchId': 'legal-perform-lsp13-sd',
                'leftOperation': true,
                'leftWidth': 200,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：要求发车时间内发车的运输单数量</div><div>应发货数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：要求签收时间内签收的运输单数量</div><div>到货总数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：要求当月回单上传时间内上传的运输单数量</div><div>回单总数量：该供应商要求当月回单上传的所有运输单数量。</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：当月运输完好商品件数求和</div><div>货物总数量：该供应商当月运输所有商品的件数求和</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '运力线上化率(%)',
                        'prop': 'onlineRateOfTransportationCapacity',
                        'width': '160px',
                        'info': '<div>运力线上化率=线上化单数/线上考核单数</div><div>线上化单数：取该供应商的所有正向订单，且发车，抵达，在途属于自动在线的TK单数求和</div><div>线上考核单数：取该供应商的所有正向订单，且发车，抵达，在途的所有TK单数求和。</div>'
                    },
                    {
                        'label': '运力线上化率得分',
                        'prop': 'onlineRateOfTransportationCapacityScore',
                        'width': '140px'
                    },
                    {
                        'label': '运力稳定率(%)',
                        'prop': 'stabilityRateOfTransportationCapacity',
                        'width': '140px',
                        'info': '<div>运力稳定率=上月高中活车辆数/上月出勤总车辆数</div>'
                    },
                    {
                        'label': '运力稳定率得分',
                        'prop': 'stabilityRateOfTransportationCapacityScore',
                        'width': '120px'
                    },
                    {
                        'label': '减分项-客户投诉得分',
                        'prop': 'customerComplaintsScore',
                        'width': '150px'
                    },
                    {
                        'label': '加分项-客户表扬得分',
                        'prop': 'customerPraiseScore',
                        'width': '150px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '申诉期截止时间',
                        'prop': 'appealDeadlingTime',
                        'width': '120px'
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/lsrm/legalPerform-30'
                    },
                    {
                        'type': 'text',
                        'label': '确认绩效',
                        'size': 'small',
                        'event': 'confirmPerform',
                        'ifHas': '/lsrm/legalPerform-10'
                    },
                    {
                        'type': 'text',
                        'label': '申诉',
                        'size': 'small',
                        'event': 'appeal',
                        'ifHas': '/lsrm/legalPerform-20'
                    },
                ]
            },
            'businessClientTable': {
                'pageId': 'legal-perform-lsp14',
                'searchId': 'legal-perform-lsp14-sd',
                'leftOperation': true,
                'leftWidth': 200,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'label': '内外部客户',
                        'prop': 'customerType',
                        'type': 'select',
                        'options': [
                            { label: '内部客户', value: '1' },
                            { label: '外部客户', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：要求发车时间内发车的运输单数量</div><div>应发货数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：要求签收时间内签收的运输单数量</div><div>到货总数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：要求当月回单上传时间内上传的运输单数量</div><div>回单总数量：该供应商要求当月回单上传的所有运输单数量。</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：当月运输完好商品件数求和</div><div>货物总数量：该供应商当月运输所有商品的件数求和</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '运力线上化率(%)',
                        'prop': 'onlineRateOfTransportationCapacity',
                        'width': '160px',
                        'info': '<div>运力线上化率=线上化单数/线上考核单数</div><div>线上化单数：取该供应商的所有正向订单，且发车，抵达，在途属于自动在线的TK单数求和</div><div>线上考核单数：取该供应商的所有正向订单，且发车，抵达，在途的所有TK单数求和。</div>'
                    },
                    {
                        'label': '运力线上化率得分',
                        'prop': 'onlineRateOfTransportationCapacityScore',
                        'width': '140px'
                    },
                    {
                        'label': '运力稳定率(%)',
                        'prop': 'stabilityRateOfTransportationCapacity',
                        'width': '140px',
                        'info': '<div>运力稳定率=上月高中活车辆数/上月出勤总车辆数</div>'
                    },
                    {
                        'label': '运力稳定率得分',
                        'prop': 'stabilityRateOfTransportationCapacityScore',
                        'width': '120px'
                    },
                    {
                        'label': '减分项-客户投诉得分',
                        'prop': 'customerComplaintsScore',
                        'width': '150px'
                    },
                    {
                        'label': '加分项-客户表扬得分',
                        'prop': 'customerPraiseScore',
                        'width': '150px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '申诉期截止时间',
                        'prop': 'appealDeadlingTime',
                        'width': '120px'
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/lsrm/legalPerform-30'
                    },
                    {
                        'type': 'text',
                        'label': '确认绩效',
                        'size': 'small',
                        'event': 'confirmPerform',
                        'ifHas': '/lsrm/legalPerform-10'
                    },
                    {
                        'type': 'text',
                        'label': '申诉',
                        'size': 'small',
                        'event': 'appeal',
                        'ifHas': '/lsrm/legalPerform-20'
                    },
                ]
            },
            'platformTable': {
                'pageId': 'legal-perform-lsp2',
                'searchId': 'legal-perform-lsp2-sd',
                'leftOperation': true,
                'leftWidth': 200,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'prop': 'siteName',
                        'label': '服务平台',
                        'width': '150px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：要求发车时间内发车的运输单数量</div><div>应发货数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：要求签收时间内签收的运输单数量</div><div>到货总数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：要求当月回单上传时间内上传的运输单数量</div><div>回单总数量：该供应商要求当月回单上传的所有运输单数量。</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：当月运输完好商品件数求和</div><div>货物总数量：该供应商当月运输所有商品的件数求和</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '运力线上化率(%)',
                        'prop': 'onlineRateOfTransportationCapacity',
                        'width': '160px',
                        'info': '<div>运力线上化率=线上化单数/线上考核单数</div><div>线上化单数：取该供应商的所有正向订单，且发车，抵达，在途属于自动在线的TK单数求和</div><div>线上考核单数：取该供应商的所有正向订单，且发车，抵达，在途的所有TK单数求和。</div>'
                    },
                    {
                        'label': '运力线上化率得分',
                        'prop': 'onlineRateOfTransportationCapacityScore',
                        'width': '140px'
                    },
                    {
                        'label': '运力稳定率(%)',
                        'prop': 'stabilityRateOfTransportationCapacity',
                        'width': '140px',
                        'info': '<div>运力稳定率=上月高中活车辆数/上月出勤总车辆数</div>'
                    },
                    {
                        'label': '运力稳定率得分',
                        'prop': 'stabilityRateOfTransportationCapacityScore',
                        'width': '120px'
                    },
                    {
                        'label': '减分项-客户投诉得分',
                        'prop': 'customerComplaintsScore',
                        'width': '150px'
                    },
                    {
                        'label': '加分项-客户表扬得分',
                        'prop': 'customerPraiseScore',
                        'width': '150px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '申诉期截止时间',
                        'prop': 'appealDeadlingTime',
                        'width': '120px'
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/lsrm/legalPerform-30'
                    },
                    {
                        'type': 'text',
                        'label': '确认绩效',
                        'size': 'small',
                        'event': 'confirmPerform',
                        'ifHas': '/lsrm/legalPerform-10'
                    },
                    {
                        'type': 'text',
                        'label': '申诉',
                        'size': 'small',
                        'event': 'appeal',
                        'ifHas': '/lsrm/legalPerform-20'
                    },
                ]
            },
            'clientTable': {
                'pageId': 'legal-perform-lsp3',
                'searchId': 'legal-perform-lsp3-sd',
                'leftOperation': true,
                'leftWidth': 200,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'prop': 'siteName',
                        'label': '服务平台',
                        'width': '150px'
                    },
                    {
                        'label': '内外部客户',
                        'prop': 'customerType',
                        'type': 'select',
                        'options': [
                            { label: '内部客户', value: '1' },
                            { label: '外部客户', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：要求发车时间内发车的运输单数量</div><div>应发货数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：要求签收时间内签收的运输单数量</div><div>到货总数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：要求当月回单上传时间内上传的运输单数量</div><div>回单总数量：该供应商要求当月回单上传的所有运输单数量。</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：当月运输完好商品件数求和</div><div>货物总数量：该供应商当月运输所有商品的件数求和</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '运力线上化率(%)',
                        'prop': 'onlineRateOfTransportationCapacity',
                        'width': '160px',
                        'info': '<div>运力线上化率=线上化单数/线上考核单数</div><div>线上化单数：取该供应商的所有正向订单，且发车，抵达，在途属于自动在线的TK单数求和</div><div>线上考核单数：取该供应商的所有正向订单，且发车，抵达，在途的所有TK单数求和。</div>'
                    },
                    {
                        'label': '运力线上化率得分',
                        'prop': 'onlineRateOfTransportationCapacityScore',
                        'width': '140px'
                    },
                    {
                        'label': '运力稳定率(%)',
                        'prop': 'stabilityRateOfTransportationCapacity',
                        'width': '140px',
                        'info': '<div>运力稳定率=上月高中活车辆数/上月出勤总车辆数</div>'
                    },
                    {
                        'label': '运力稳定率得分',
                        'prop': 'stabilityRateOfTransportationCapacityScore',
                        'width': '120px'
                    },
                    {
                        'label': '减分项-客户投诉得分',
                        'prop': 'customerComplaintsScore',
                        'width': '150px'
                    },
                    {
                        'label': '加分项-客户表扬得分',
                        'prop': 'customerPraiseScore',
                        'width': '150px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '申诉期截止时间',
                        'prop': 'appealDeadlingTime',
                        'width': '120px'
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/lsrm/legalPerform-30'
                    },
                    {
                        'type': 'text',
                        'label': '确认绩效',
                        'size': 'small',
                        'event': 'confirmPerform',
                        'ifHas': '/lsrm/legalPerform-10'
                    },
                    {
                        'type': 'text',
                        'label': '申诉',
                        'size': 'small',
                        'event': 'appeal',
                        'ifHas': '/lsrm/legalPerform-20'
                    },
                ]
            },
        },
        'delivery_new': delivery_new_lsp,
        'transport': {
            'companyTable': {
                'pageId': 'legal-perform-lsp4',
                'searchId': 'legal-perform-lsp4-sd',
                'leftOperation': true,
                'leftWidth': 200,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '日度累计得分',
                        'prop': 'dailyCumulativeScore',
                        'width': '120px',
                    },
                    {
                        'label': '日度累计排名',
                        'prop': 'dailyCumulativeRanking',
                        'width': '120px',
                        'info': '每日更新当月1日到前一日的累计得分和排名',
                    },
                    {
                        label: '日度绩效等级',
                        prop: 'dailyPerformanceGrade',
                        width: '120px',
                        type: 'select',
                        optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        options: [],
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：要求发车时间内发车的运输单数量</div><div>应发货数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：要求签收时间内签收的运输单数量</div><div>到货总数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：要求当月回单上传时间内上传的运输单数量</div><div>回单总数量：该供应商要求当月回单上传的所有运输单数量。</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：当月运输完好商品件数求和</div><div>货物总数量：该供应商当月运输所有商品的件数求和</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '罚扣金额',
                        'prop': 'penaltyDeductionAmount',
                        'width': '120px',
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '申诉期截止时间',
                        'prop': 'appealDeadlingTime',
                        'width': '120px'
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/lsrm/legalPerform-30'
                    },
                    {
                        'type': 'text',
                        'label': '确认绩效',
                        'size': 'small',
                        'event': 'confirmPerform',
                        'ifHas': '/lsrm/legalPerform-10'
                    },
                    {
                        'type': 'text',
                        'label': '申诉',
                        'size': 'small',
                        'event': 'appeal',
                        'ifHas': '/lsrm/legalPerform-20'
                    },
                ]
            },
            'companyClientTable': {
                'pageId': 'legal-perform-lsp8',
                'searchId': 'legal-perform-lsp8-sd',
                'leftOperation': true,
                'leftWidth': 200,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'label': '内外部客户',
                        'prop': 'customerType',
                        'type': 'select',
                        'options': [
                            { label: '内部客户', value: '1' },
                            { label: '外部客户', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '日度累计得分',
                        'prop': 'dailyCumulativeScore',
                        'width': '120px',
                    },
                    {
                        'label': '日度累计排名',
                        'prop': 'dailyCumulativeRanking',
                        'width': '120px',
                        'info': '每日更新当月1日到前一日的累计得分和排名',
                    },
                    {
                        label: '日度绩效等级',
                        prop: 'dailyPerformanceGrade',
                        width: '120px',
                        type: 'select',
                        optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        options: [],
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：要求发车时间内发车的运输单数量</div><div>应发货数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：要求签收时间内签收的运输单数量</div><div>到货总数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：要求当月回单上传时间内上传的运输单数量</div><div>回单总数量：该供应商要求当月回单上传的所有运输单数量。</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：当月运输完好商品件数求和</div><div>货物总数量：该供应商当月运输所有商品的件数求和</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '申诉期截止时间',
                        'prop': 'appealDeadlingTime',
                        'width': '120px'
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/lsrm/legalPerform-30'
                    },
                    {
                        'type': 'text',
                        'label': '确认绩效',
                        'size': 'small',
                        'event': 'confirmPerform',
                        'ifHas': '/lsrm/legalPerform-10'
                    },
                    {
                        'type': 'text',
                        'label': '申诉',
                        'size': 'small',
                        'event': 'appeal',
                        'ifHas': '/lsrm/legalPerform-20'
                    },
                ]
            },
            'businessTable': {
                'pageId': 'legal-perform-lsp15',
                'searchId': 'legal-perform-lsp15-sd',
                'leftOperation': true,
                'leftWidth': 200,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '日度累计得分',
                        'prop': 'dailyCumulativeScore',
                        'width': '120px',
                    },
                    {
                        'label': '日度累计排名',
                        'prop': 'dailyCumulativeRanking',
                        'width': '120px',
                        'info': '每日更新当月1日到前一日的累计得分和排名',
                    },
                    {
                        label: '日度绩效等级',
                        prop: 'dailyPerformanceGrade',
                        width: '120px',
                        type: 'select',
                        optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        options: [],
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：要求发车时间内发车的运输单数量</div><div>应发货数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：要求签收时间内签收的运输单数量</div><div>到货总数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：要求当月回单上传时间内上传的运输单数量</div><div>回单总数量：该供应商要求当月回单上传的所有运输单数量。</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：当月运输完好商品件数求和</div><div>货物总数量：该供应商当月运输所有商品的件数求和</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '罚扣金额',
                        'prop': 'penaltyDeductionAmount',
                        'width': '120px',
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '申诉期截止时间',
                        'prop': 'appealDeadlingTime',
                        'width': '120px'
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/lsrm/legalPerform-30'
                    },
                    {
                        'type': 'text',
                        'label': '确认绩效',
                        'size': 'small',
                        'event': 'confirmPerform',
                        'ifHas': '/lsrm/legalPerform-10'
                    },
                    {
                        'type': 'text',
                        'label': '申诉',
                        'size': 'small',
                        'event': 'appeal',
                        'ifHas': '/lsrm/legalPerform-20'
                    },
                ]
            },
            'businessClientTable': {
                'pageId': 'legal-perform-lsp16',
                'searchId': 'legal-perform-lsp16-sd',
                'leftOperation': true,
                'leftWidth': 200,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'label': '内外部客户',
                        'prop': 'customerType',
                        'type': 'select',
                        'options': [
                            { label: '内部客户', value: '1' },
                            { label: '外部客户', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '日度累计得分',
                        'prop': 'dailyCumulativeScore',
                        'width': '120px',
                    },
                    {
                        'label': '日度累计排名',
                        'prop': 'dailyCumulativeRanking',
                        'width': '120px',
                        'info': '每日更新当月1日到前一日的累计得分和排名',
                    },
                    {
                        label: '日度绩效等级',
                        prop: 'dailyPerformanceGrade',
                        width: '120px',
                        type: 'select',
                        optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        options: [],
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：要求发车时间内发车的运输单数量</div><div>应发货数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：要求签收时间内签收的运输单数量</div><div>到货总数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：要求当月回单上传时间内上传的运输单数量</div><div>回单总数量：该供应商要求当月回单上传的所有运输单数量。</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：当月运输完好商品件数求和</div><div>货物总数量：该供应商当月运输所有商品的件数求和</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '申诉期截止时间',
                        'prop': 'appealDeadlingTime',
                        'width': '120px'
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/lsrm/legalPerform-30'
                    },
                    {
                        'type': 'text',
                        'label': '确认绩效',
                        'size': 'small',
                        'event': 'confirmPerform',
                        'ifHas': '/lsrm/legalPerform-10'
                    },
                    {
                        'type': 'text',
                        'label': '申诉',
                        'size': 'small',
                        'event': 'appeal',
                        'ifHas': '/lsrm/legalPerform-20'
                    },
                ]
            },
            'platformTable': {
                'pageId': 'legal-perform-5',
                'searchId': 'legal-perform-lsp5-sd',
                'leftOperation': true,
                'leftWidth': 200,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'prop': 'siteName',
                        'label': '服务平台',
                        'width': '150px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '日度累计得分',
                        'prop': 'dailyCumulativeScore',
                        'width': '120px',
                    },
                    {
                        'label': '日度累计排名',
                        'prop': 'dailyCumulativeRanking',
                        'width': '120px',
                        'info': '每日更新当月1日到前一日的累计得分和排名',
                    },
                    {
                        label: '日度绩效等级',
                        prop: 'dailyPerformanceGrade',
                        width: '120px',
                        type: 'select',
                        optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        options: [],
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：要求发车时间内发车的运输单数量</div><div>应发货数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：要求签收时间内签收的运输单数量</div><div>到货总数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：要求当月回单上传时间内上传的运输单数量</div><div>回单总数量：该供应商要求当月回单上传的所有运输单数量。</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：当月运输完好商品件数求和</div><div>货物总数量：该供应商当月运输所有商品的件数求和</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '申诉期截止时间',
                        'prop': 'appealDeadlingTime',
                        'width': '120px'
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/lsrm/legalPerform-30'
                    },
                    {
                        'type': 'text',
                        'label': '确认绩效',
                        'size': 'small',
                        'event': 'confirmPerform',
                        'ifHas': '/lsrm/legalPerform-10'
                    },
                    {
                        'type': 'text',
                        'label': '申诉',
                        'size': 'small',
                        'event': 'appeal',
                        'ifHas': '/lsrm/legalPerform-20'
                    },
                ]
            },
            'clientTable': {
                'pageId': 'legal-perform-lsp6',
                'searchId': 'legal-perform-lsp6-sd',
                'leftOperation': true,
                'leftWidth': 200,
                'height': 'calc(100vh - 316px)',
                'columns': [
                    {
                        'label': '考核月份',
                        'prop': 'month',
                        'width': '80px'
                    },
                    {
                        'prop': 'companyName',
                        'label': '分公司',
                        'width': '150px'
                    },
                    {
                        'prop': 'businessCenterName',
                        'label': '经营中心',
                        'width': '150px'
                    },
                    {
                        'prop': 'siteName',
                        'label': '服务平台',
                        'width': '150px'
                    },
                    {
                        'label': '内外部客户',
                        'prop': 'customerType',
                        'type': 'select',
                        'options': [
                            { label: '内部客户', value: '1' },
                            { label: '外部客户', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '供应商编码',
                        'prop': 'supplierCode',
                        'width': '120px'
                    },
                    {
                        'label': '供应商名称',
                        'prop': 'supplierNameCn',
                        'width': '150px'
                    },
                    {
                        'label': '订单数',
                        'prop': 'orderNum',
                        'width': '80px',
                        'info': '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>'
                    },
                    {
                        'label': '总得分',
                        'prop': 'countScore',
                        'width': '80px'
                    },
                    {
                        'label': '日度累计得分',
                        'prop': 'dailyCumulativeScore',
                        'width': '120px',
                    },
                    {
                        'label': '日度累计排名',
                        'prop': 'dailyCumulativeRanking',
                        'width': '120px',
                        'info': '每日更新当月1日到前一日的累计得分和排名',
                    },
                    {
                        label: '日度绩效等级',
                        prop: 'dailyPerformanceGrade',
                        width: '120px',
                        type: 'select',
                        optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        options: [],
                    },
                    {
                        'label': '发运及时率(%)',
                        'prop': 'timelyShippingRate',
                        'width': '160px',
                        'info': '<div>发运及时率=发货及时数量/应发货数量</div><div>发车及时数量：要求发车时间内发车的运输单数量</div><div>应发货数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '发运及时率得分',
                        'prop': 'timelyShippingRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '应发货数量',
                        'prop': 'dispatchIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '发货及时数量',
                        'prop': 'dispatchIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时率(%)',
                        'prop': 'timelyDeliveryRate',
                        'width': '160px',
                        'info': '<div>到货及时率=到货及时数量/到货总数量</div><div>到货及时数量：要求签收时间内签收的运输单数量</div><div>到货总数量：该供应商当月的所有运输单数量</div>'
                    },
                    {
                        'label': '到货及时率得分',
                        'prop': 'timelyDeliveryRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '到货总数量',
                        'prop': 'arrivalIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '到货及时数量',
                        'prop': 'arrivalIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时率(%)',
                        'prop': 'timelyResponseRate',
                        'width': '160px',
                        'info': '<div>回单及时率=回单及时数量/回单总数量</div><div>回单及时数量：要求当月回单上传时间内上传的运输单数量</div><div>回单总数量：该供应商要求当月回单上传的所有运输单数量。</div>'
                    },
                    {
                        'label': '回单及时率得分',
                        'prop': 'timelyResponseRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '回单总数量',
                        'prop': 'receiptIntimeAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '回单及时数量',
                        'prop': 'receiptIntimeCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好率(%)',
                        'prop': 'goodsIntegrityRate',
                        'width': '160px',
                        'info': '<div>货物完好率=货物完好数量/货物总数量</div><div>货物完好数量：当月运输完好商品件数求和</div><div>货物总数量：该供应商当月运输所有商品的件数求和</div>'
                    },
                    {
                        'label': '货物完好率得分',
                        'prop': 'goodsIntegrityRateScore',
                        'width': '120px'
                    },
                    {
                        'label': '货物总数量',
                        'prop': 'goodsIntactAllCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '货物完好数量',
                        'prop': 'goodsIntactCntTotal',
                        'width': '120px'
                    },
                    {
                        'label': '绩效等级',
                        'prop': 'performanceStarRating',
                        'type': 'select',
                        'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                        'options': [],
                        'width': '120px',
                        'info': '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>'
                    },
                    {
                        'label': '是否申诉',
                        'prop': 'isAppeal',
                        'type': 'select',
                        'options': [
                            { label: '否', value: '1' },
                            { label: '是', value: '2' },
                        ],
                        'width': '120px'
                    },
                    {
                        'label': '绩效状态',
                        'prop': 'performanceStatus',
                        'type': 'select',
                        'optionNum': 'LEGAL_PERSON_PERFORMANCE',
                        'options': [],
                        'width': '120px',
                        'info': '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>'
                    },
                    {
                        'label': '申诉期截止时间',
                        'prop': 'appealDeadlingTime',
                        'width': '120px'
                    },
                ],
                'action': [
                    {
                        'type': 'text',
                        'label': '查看申诉',
                        'size': 'small',
                        'event': 'viewAppeal',
                        'ifHas': '/lsrm/legalPerform-30'
                    },
                    {
                        'type': 'text',
                        'label': '确认绩效',
                        'size': 'small',
                        'event': 'confirmPerform',
                        'ifHas': '/lsrm/legalPerform-10'
                    },
                    {
                        'type': 'text',
                        'label': '申诉',
                        'size': 'small',
                        'event': 'appeal',
                        'ifHas': '/lsrm/legalPerform-20'
                    },
                ]
            },
        },
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100]
    }
};
export default config;